import { TEmployeeRole, TRESPONSE_SPAREPART_REQUEST_LIST, TSparePartRequestStatus } from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';
import * as moment from 'moment';
import * as _ from 'lodash';

export const SPAREPART_REQUEST_LIST_TABLE_MODEL = {
  createModel: (
    items: TRESPONSE_SPAREPART_REQUEST_LIST['requests'],
    status: TSparePartRequestStatus,
    showSubReason: boolean,
    employeeRole?: TEmployeeRole[number] | undefined,
  ) => {
    return ModifiersZTableModel.createTableModel(
      items,
      {
        padding: 8,
        select:
          status === 'PENDING'
            ? {
                position: 'START',
                isMulti: true,
                size: 'DEFAULT',
              }
            : undefined,
        headerConfig: _.compact([
          {
            type: 'TEXT_CELL',
            text: 'table_model.Date/Time',
          },
          employeeRole === 'FACTORY_GROUP_ADMIN'
            ? {
                type: 'TEXT_CELL',
                text: 'FACTORY ID',
              }
            : undefined,
          {
            type: 'TEXT_CELL',
            text: 'table_model.FACTORYSERIALID',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.RequestReason',
          },
          showSubReason
            ? {
                type: 'TEXT_CELL',
                text: 'table_model.BrokenReason',
              }
            : undefined,
          {
            type: 'TEXT_CELL',
            text: 'table_model.LocationCode',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.RequestRaisedby',
          },
          {
            type: 'TEXT_CELL',
            text: '',
            widthInPx: 32,
          },
          {
            type: 'TEXT_CELL',
            text: '',
            widthInPx: 32,
          },
        ]),
      },
      (item) => {
        return {
          type: 'ROW',
          rowItem: item,
          isSelected: false,
          cells: _.compact([
            {
              type: 'TEXT_LIST_CELL',
              text: [
                moment(new Date(item.requestedAt)).format('YYYY/MM/DD'),
                moment(new Date(item.requestedAt)).format('hh:mm A'),
              ],
            },
            employeeRole === 'FACTORY_GROUP_ADMIN'
              ? {
                  type: 'TEXT_CELL',
                  text: item.factoryId,
                }
              : undefined,
            {
              type: 'TEXT_CELL',
              text: item.machineDescription.factorySerialNumber,
            },
            {
              type: 'TEXT_CELL',
              text: item.requestReason,
            },
            showSubReason
              ? {
                  type: 'TEXT_CELL',
                  text: item.subReasonOpt || '--',
                }
              : undefined,
            {
              type: 'TEXT_CELL',
              text: item.locationInfo.locationDisplayCode,
            },
            {
              type: 'TEXT_CELL',
              text: item.requestedBy.employeeName,
            },
            {
              type: 'ACTION_CELL',
              actionType: 'VIEW',
              asIcon: true,
            },
            {
              type: 'ACTION_CELL',
              actionType: 'CUSTOM_ACTION',
              customTxt: 'Expand',
            },
          ]),
        };
      },
    );
  },
};
